import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HL7 } from '../../constant';

export interface DeleteDraftDistributionPayload {
  distributionId: string;
}

export const deleteDraftDistributionApi = createAsyncThunk(
  'hl7/deleteDraftDistribution',
  async (payload: DeleteDraftDistributionPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const response = await fetch(HL7.DELETE_DRAFT(payload.distributionId), {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) {
        return rejectWithValue(result.msg || `Delete draft failed: ${response.status}`);
      }
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
